import {useMemo} from 'react';
import {useNavigate} from 'react-router';
import type {WorkSummary} from 'api/types';
import type {DataFormConfiguration} from 'schema/types';
import type {Agent} from 'services/agent/types';
import {useLocalization} from 'localization';
import {useDefaultAdornementResolver} from 'schema';
import {agentWorkSummaryTableConfig} from 'schemas/configurations/table';
import {EditPartCity} from '../components/EditPartCity';

export const useAgentFormConfiguration = (): Partial<
  DataFormConfiguration<Agent>
> => {
  const adornmentResolver = useDefaultAdornementResolver();
  const {t} = useLocalization();
  const navigate = useNavigate();

  return useMemo(() => {
    const config: Partial<DataFormConfiguration<Agent>> = {
      schemaContainers: {
        prizes: 'NoContainer',
      },
      parts: {
        works: {
          label: t('form.global.field.works.label'),
          empty: t('form.global.field.works.empty'),
          table: agentWorkSummaryTableConfig,
          onRowClick: row => {
            if (row && (row as WorkSummary).id) {
              navigate(`/metadata/${(row as WorkSummary).id}`);
            }
          },
        },
        links: {
          label: t('form.global.field.links.label'),
          showWhenReadonlyAndEmpty: false,
        },
        gender: {
          label: t('form.global.field.gender.label'),
          layout: {
            width: '14em',
          },
        },
        isni: {
          label: t('form.global.field.isni.label'),
          layout: {
            width: '12em',
          },
        },
        subsidiary: {
          label: t('form.corporation.field.subsidiary.label'),
          showWhenReadonlyAndEmpty: false,
        },
      },
      adornmentResolver,
      showWhenReadonlyAndEmpty: true,
      compareReadonly: true,
      dataFormPartRenderers: {
        place: EditPartCity,
      },
    };

    return config;
  }, [adornmentResolver, t, navigate]);
};
